module.exports = __webpack_public_path__ + "img/rappel.f5671d24.svg";